var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCropDateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.45,
    height: 21.328,
    viewBox: "0 0 21.45 21.328",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9084",
    "data-name": "Group 9084",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3299",
    "data-name": "Path 3299",
    d: "M4173.856,261.412c0,.263,0,.509,0,.755,0,.429,0,.858.006,1.287a1.33,1.33,0,0,0,.986,1.237,1.357,1.357,0,0,0,1.461-.492,1.389,1.389,0,0,0,.269-.844c0-.623,0-1.246,0-1.867,0-.021,0-.04,0-.067h10.394v.313c0,.561-.006,1.124,0,1.685a1.361,1.361,0,0,0,2.533.656,1.266,1.266,0,0,0,.184-.7c-.006-.325,0-.65,0-.974v-.994h.389c.575,0,1.151,0,1.724,0a.662.662,0,0,1,.693.706q0,2.183,0,4.364v7.886q0,2.7,0,5.4a2.5,2.5,0,0,1-.009.3.659.659,0,0,1-.66.569c-.637,0-1.273,0-1.909,0h-16.3c-.627,0-1.253-.012-1.877,0a.715.715,0,0,1-.693-.7c.01-1.63,0-3.261,0-4.892q0-3.314,0-6.627c0-.957,0-1.915,0-2.872q0-1.726,0-3.451a.653.653,0,0,1,.7-.7h2.1Zm7.9,18.347h.151l2.945.005c.668,0,1.339,0,2.009,0,.755,0,1.509-.005,2.263-.005.612,0,1.224.005,1.838.005a.608.608,0,0,0,.661-.663v-2.689q0-2.508,0-5.014,0-2.447,0-4.892a.618.618,0,0,0-.679-.679c-.666,0-1.333,0-2,0l-3.947-.006c-.664,0-1.327.006-1.991.006l-4.607-.006c-.566,0-1.137.006-1.7.006h-4.113a.607.607,0,0,0-.646.647c0,.652,0,1.3,0,1.959q0,2.516,0,5.033,0,2.813,0,5.623a.6.6,0,0,0,.655.665c1,0,2,0,3,0l2.74.005c.49,0,.981,0,1.472-.005Z",
    transform: "translate(-4171.052 -259.322)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3300",
    "data-name": "Path 3300",
    d: "M4183.879,262.252c0-.537,0-1.075,0-1.612a.794.794,0,0,1,.421-.746.768.768,0,0,1,.854.044.757.757,0,0,1,.341.646q0,1.283-.006,2.566c0,.266.012.534-.013.8a.79.79,0,0,1-.747.67.8.8,0,0,1-.795-.527,1.051,1.051,0,0,1-.048-.288c0-.518,0-1.035,0-1.553Z",
    transform: "translate(-4167.401 -259.785)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3301",
    "data-name": "Path 3301",
    d: "M4175.272,262.165c0,.578.009,1.157,0,1.735a.785.785,0,0,1-.634.7.81.81,0,0,1-.863-.389.86.86,0,0,1-.1-.428q0-1.578,0-3.154a.809.809,0,0,1,.767-.837.794.794,0,0,1,.843.771c0,.534,0,1.069,0,1.6Z",
    transform: "translate(-4170.31 -259.785)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3302",
    "data-name": "Path 3302",
    d: "M4181.529,272.373c0-.421-.007-.842,0-1.263.008-.451.188-.668.623-.677q1.326-.027,2.652,0a.584.584,0,0,1,.616.65q.013,1.283,0,2.567a.614.614,0,0,1-.653.67c-.855.017-1.712.015-2.568,0a.611.611,0,0,1-.669-.688C4181.522,273.214,4181.529,272.793,4181.529,272.373Z",
    transform: "translate(-4168.072 -256.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3303",
    "data-name": "Path 3303",
    d: "M4174.056,268.593c0-.407-.007-.813,0-1.22.009-.438.208-.67.625-.677q1.328-.023,2.65,0a.576.576,0,0,1,.613.648q.012,1.281,0,2.565a.6.6,0,0,1-.644.668c-.869.018-1.74.019-2.609,0-.424-.009-.626-.248-.633-.678S4174.056,269.027,4174.056,268.593Z",
    transform: "translate(-4170.197 -257.823)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3304",
    "data-name": "Path 3304",
    d: "M4179.729,266.687c.408,0,.814-.006,1.221,0,.495.01.726.231.731.715q.012,1.239,0,2.48a.624.624,0,0,1-.672.695q-1.282.023-2.564,0c-.446-.009-.65-.243-.654-.7q-.012-1.26,0-2.522a.578.578,0,0,1,.638-.663c.434-.015.869,0,1.3,0Z",
    transform: "translate(-4169.135 -257.823)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3305",
    "data-name": "Path 3305",
    d: "M4174.056,272.337c0-.421-.008-.843,0-1.263a.58.58,0,0,1,.621-.642q1.326-.025,2.653,0a.572.572,0,0,1,.61.647q.015,1.285,0,2.569a.6.6,0,0,1-.644.672q-1.3.027-2.608,0a.6.6,0,0,1-.635-.679C4174.049,273.207,4174.056,272.771,4174.056,272.337Z",
    transform: "translate(-4170.2 -256.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3306",
    "data-name": "Path 3306",
    d: "M4181.688,272.358c0,.421.007.843,0,1.264-.007.452-.217.692-.658.7-.855.017-1.711.015-2.567,0a.616.616,0,0,1-.665-.7c0-.843-.006-1.684,0-2.526a.589.589,0,0,1,.637-.67q1.305-.025,2.609,0c.432.008.632.231.643.664S4181.688,271.938,4181.688,272.358Z",
    transform: "translate(-4169.132 -256.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3307",
    "data-name": "Path 3307",
    d: "M4183.493,266.688c.407,0,.814-.008,1.22,0,.474.012.705.232.708.692q.014,1.262,0,2.522a.61.61,0,0,1-.65.672q-1.3.027-2.608,0c-.422-.009-.627-.244-.632-.677q-.012-1.283,0-2.565a.568.568,0,0,1,.616-.64c.448-.018.9-.005,1.345-.005Zm1.151.778h-2.329v2.33h2.329Z",
    transform: "translate(-4168.07 -257.823)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCropDateIcon);
export default __webpack_public_path__ + "static/media/cropDateIcon.b5d36e35b990ef4a3ad24af535704ef4.svg";
export { ForwardRef as ReactComponent };